/** @prettier */
import {GraphDataRange} from '../../../../Type/TypeDef';
import {graph} from '../../../../define';
import {barGraphBasicSetting} from './barGraphBasicSetting';
import {TFunction} from 'i18next';

/**
 * 消費電力グラフ 個別表示 その他 の表示設定
 * @param props props
 * @returns 表示設定
 */
export const aggregationUnitBarGraphSetting = (props: {
  xLabel: string[]; //X軸のラベル
  dateRange: GraphDataRange; //データ取得範囲
  csvFileNameDate: string; //CSVファイルの名前（日付部分）
  csvFileNameTarget: string; //CSVファイルの名前（サイトの名前 + グラフの対象の名前）
  barGraphData: ApexAxisChartSeries['0']['data']; //グラフデータ
  comparisonBarGraphData: ApexAxisChartSeries['0']['data']; //グラフデータ(別の日)
  trans: TFunction; //翻訳関数
}) => {
  /** Apex Chartsのseries設定
   * - name グラフの凡例
   * - type グラフの種類
   * - group グラフデータのグループ
   * - data グラフデータ
   */
  let seriesProps: ApexAxisChartSeries = [];

  //COMPARISONボタンの押下毎に、表示するグラフと凡例の数を切り替える。
  if (props.comparisonBarGraphData.length > 0) {
    //COMPARISONボタンの押下回数が奇数の場合、グラフと凡例を2つずつ表示する。
    //奇数:comparison**のデータをBarChartGraphから受け取る。(データ長≠0)
    //偶数:comparison**のデータをBarChartGraphから受け取らない。(データ長＝0)
    seriesProps = [
      {
        name: `${props.trans(
          'aggregationUnitBarGraphSetting.graphItem.comparisonAC'
        )}`,
        group: 'comparisonBarGraphPowerConsumption',
        data: props.comparisonBarGraphData,
      },
      {
        name: `${props.trans('aggregationUnitBarGraphSetting.graphItem.ac')}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphData,
      },
    ];
  } else {
    seriesProps = [
      {
        name: `${props.trans('aggregationUnitBarGraphSetting.graphItem.ac')}`,
        group: 'barGraphPowerConsumption',
        data: props.barGraphData,
      },
    ];
  }

  /** Apex Chartsのoptions設定
   * - xLabel X軸に表示するラベル
   * - dateRange データ取得範囲
   * - csvFileNameDate csvファイル名に表示する日付
   * - csvFileNameTarget csvファイル名に表示するサイト名 + ユニット名
   * - trans 翻訳関数
   */
  let optionProps = barGraphBasicSetting({
    xLabel: props.xLabel,
    dateRange: props.dateRange,
    csvFileNameDate: props.csvFileNameDate,
    csvFileNameTarget: props.csvFileNameTarget,
    trans: props.trans,
  });

  /** グラフ配色一覧 */
  const graphColor = [
    graph.GRAPH_COLOR_COOL, //Cool 0 消費電力AC
    graph.GRAPH_COLOR_LIGHT_COOL, //Light Cool 消費電力AC（比較）
  ];

  //COMPARISONボタンの押下毎に、グラフの配色を切り替える。
  if (props.comparisonBarGraphData.length > 0) {
    //奇数:comparison**のデータをBarChartGraphから受け取る。(データ長≠0)
    //偶数:comparison**のデータをBarChartGraphから受け取らない。(データ長＝0)
    optionProps.colors = [graphColor[1], graphColor[0]];
  } else {
    optionProps.colors = [graphColor[0]];
  }

  return {
    series: seriesProps,
    options: optionProps,
  };
};
